import { actionNames } from "constants/index";
const mapDispatchToProps = (dispatch) => ({});

export default mapDispatchToProps;
